var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9764 2.5H7.50008C5.92873 2.5 5.14306 2.5 4.6549 2.98816C4.16675 3.47631 4.16675 4.26198 4.16675 5.83333V14.1667C4.16675 15.738 4.16675 16.5237 4.6549 17.0118C5.14306 17.5 5.92873 17.5 7.50008 17.5H12.5001C14.0714 17.5 14.8571 17.5 15.3453 17.0118C15.8334 16.5237 15.8334 15.738 15.8334 14.1667V7.35702C15.8334 7.0164 15.8334 6.84608 15.77 6.69294C15.7065 6.5398 15.5861 6.41937 15.3453 6.17851L12.1549 2.98816C11.914 2.7473 11.7936 2.62687 11.6405 2.56343C11.4873 2.5 11.317 2.5 10.9764 2.5Z",
    stroke: "#707070",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.833L12.5 10.833",
    stroke: "#707070",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.167L10.8333 14.167",
    stroke: "#707070",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 2.5V5.83333C10.8333 6.61901 10.8333 7.01184 11.0773 7.25592C11.3214 7.5 11.7142 7.5 12.4999 7.5H15.8333",
    stroke: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsIcon);
export default __webpack_public_path__ + "static/media/newsIcon.2a169e7358a5bdbe7c69eae9f586377f.svg";
export { ForwardRef as ReactComponent };